export default {
  form: {
    address: {
      label: 'Adresă',
      placeholder: 'Adresă',
    },
    zip_code: {
      label: 'Cod poștal',
      placeholder: 'Cod poștal',
    },
    city: {
      label: 'Oraș',
      placeholder: 'Oraș',
    },
    start_time: {
      label: 'Oră de începere',
      placeholder: 'ex. 11:00',
    },
    name: {
      label: 'Numele locației (opțional)',
      placeholder: 'ex. Lângă Fernsehturm',
      tooltip:
        'Introducerea unui nume de locație îi poate ajuta pe clienți să identifice locația, ex. „Lângă Fernsehturm"',
    },
    note: {
      label: 'Notă',
      placeholder: 'Introduceți notă',
    },
  },
  buttons: {
    add_location: 'Adaugă locație',
  },
};
